import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { ApiClient, getGtcHubClientInstance } from 'src/client/apiClient';
import {
  SUBMIT_INTEREST_API_NAME,
  UNKNOWN_PARTNER,
} from 'src/constants/ApiConstants';
import {
  CreateInterestRequest,
  CreateInterestResponse,
} from 'src/types/CreateInterest';

export function useCreateInterest(
  componentName: string,
): UseMutationResult<
  CreateInterestResponse,
  unknown,
  CreateInterestRequest,
  unknown
> {
  return useMutation<CreateInterestResponse, unknown, CreateInterestRequest>({
    mutationFn: (createInterestRequest: CreateInterestRequest) => {
      const client: ApiClient = getGtcHubClientInstance();

      return client.client.request({
        url: '/interest',
        method: 'post',
        meta: {
          apiName: SUBMIT_INTEREST_API_NAME,
          component: componentName,
        },
        data: {
          ...createInterestRequest,
          partner: createInterestRequest.partner ?? UNKNOWN_PARTNER,
        },
      });
    },
  });
}
